module.exports = __webpack_public_path__ + "img/電気回路_3_10_4.751b1a2e.png";